import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setCategoryOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-2xl ${scrolled || !isHome ? 'text-primary-500' : 'text-white'}`}>
              风车动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? scrolled || !isHome ? 'text-primary-500' : 'text-white'
                  : scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.startsWith('/category')
                    ? scrolled || !isHome ? 'text-primary-500' : 'text-white'
                    : scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line text-base transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-background-50 rounded-lg shadow-lg border border-background-200/70 py-2 w-40">
                  {categories.filter(c => c.slug !== 'all').map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? scrolled || !isHome ? 'text-primary-500' : 'text-white'
                  : scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm border transition-colors ${
              scrolled || !isHome
                ? 'border-background-200 bg-background-100 text-foreground-500'
                : 'border-white/30 bg-white/10 text-white/70'
            }`}>
              <i className="ri-search-line text-base"></i>
              <input
                type="text"
                placeholder="搜索动漫..."
                className="bg-transparent outline-none text-sm w-32 placeholder:text-current/50"
              />
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 py-2">首页</Link>
            <div className="text-sm font-medium text-foreground-700 py-2">分类</div>
            <div className="grid grid-cols-3 gap-2 pl-2">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-500 py-1"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <Link to="/about" className="text-sm font-medium text-foreground-700 py-2">关于我们</Link>
            <div className="flex items-center gap-2 px-3 py-2 rounded-full border border-background-200 bg-background-100">
              <i className="ri-search-line text-sm text-foreground-400"></i>
              <input
                type="text"
                placeholder="搜索动漫..."
                className="bg-transparent outline-none text-sm w-full text-foreground-700 placeholder:text-foreground-400"
              />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}